export default {
  ADD: 'ADD_SHAPE',
  REMOVE: 'REMOVE_SHAPE',
  UPDATE: 'UPDATE_SHAPE',
}
